import { CloseOutlined } from "@ant-design/icons";
import { Button, Form, FormInstance, FormProps, Input, Modal, Radio, Select } from "antd";
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { addMessagingProviderConfigEmail } from "../../../../api/generalConfiguration/generalConfigurationApi";
import { getSLCategoryCarByPermission, getSLUnitByPermission, ISelectOption } from "../../../../api/selectOptions/selectOptionsApi";
import { convertNationwideValueToTree_V2 } from "../../../../api/unit/unitApi";
import useToast from "../../../../hook/useToast";
import { DataAuthType, DataEncryptionType } from "../../../../services/data";
import { selectorCategoryCarIds } from "../../../../store/slices/categoryCarSlice";
import { selectorInfoUser } from "../../../../store/slices/infoUserSlice";
import { fommatSelectOption } from "../../../../until";
import { TreeSelectCustom_V2 } from "../../AccountsManagement/Components/TreeSelectCustom_V2";
import './styles.scss'

interface ModalProps {
  isOpen: boolean
  type: number

  gListEmailConfig?: (pageNumber?: number, pageSize?: number) => void
  closeModal: () => void
}

const ModalCreateEmail: React.FC<ModalProps> = ({
  isOpen, type,
  closeModal, gListEmailConfig
}) => {
  useEffect(() => {


    let unmounted = false;
    (async () => {
      const [resCar, resNationwide] = await Promise.all([
        getSLCategoryCarByPermission(permittedCategoryCarIds), getSLUnitByPermission(unitTemp)
      ]);
      if (!unmounted && resCar?.status)
        setSLCategoryCar([
          { label: "Tất cả", value: -1 },
          ...fommatSelectOption(resCar.data)
        ])
      if (!unmounted && resNationwide?.status)
        setSLNationwide(convertNationwideValueToTree_V2(resNationwide.data));

    })();

  }, []);

  const { unitTemp, id } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const [form] = useForm();

  const unitIds = Form.useWatch("unitIds", form) as number[] | undefined;
  const pushToast = useToast();
  const inputRef = useRef<FormInstance>(null);

  const [valuesUnitList, setValuesUnitList] = useState<number[]>([]);

  const [sLCategoryCar, setSLCategoryCar] = useState<ISelectOption[]>([]);
  const [sLNationwide, setSLNationwide] = useState<any>()







  const onFinish: FormProps["onFinish"] = async (values) => {
    const { email, categoryCarIds, unitIds, authType, encryptionType, smtpHost, smtpPort, smtpUsername, smtpPassword, emailSignature } = values

    const result = await addMessagingProviderConfigEmail(
      email,
      categoryCarIds,
      unitIds,
      smtpHost,
      smtpPort,
      smtpUsername,
      smtpPassword,
      authType,
      encryptionType,
      emailSignature
    )
    if (result?.status) {
      pushToast(result.message, "success", 2000)
      closeModal();
      gListEmailConfig?.()
    } else {
      pushToast(result.message, "error", 2000)
    }
  };

  useEffect(() => {
    if (isOpen) {

    } else {
      form.resetFields();
      setValuesUnitList([])
    }
  }, [isOpen])

  useEffect(() => {
    console.log(unitIds)
  }, [unitIds])
  return (
    <Form
      layout="vertical"
      className=" custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2"

      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >

      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center pb-4  w-full border-b-F0F0F0 rounded-2 overflow-hidden">
          <span className="text-base text-344054 fw-500 font-medium">Tạo cấu hình Email</span>
          <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
        </div>}
        open={isOpen}
        onCancel={closeModal}
        centered
        className=" custom-modal-ant-history"
        destroyOnHidden
        closeIcon={false}
        footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center pt-2  w-full border-t-F0F0F0">
          <div className="custom-page-css w-full flex justify-end gap-2 mt-4">
            <Button
              onClick={closeModal}
            >
              Huỷ
            </Button>
            <Button
              type="primary"
              onClick={() => form.submit()}
            >
              Lưu
            </Button>
          </div>
        </div>}
      >
        <div className="custom-modal-ant-history-child custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2 py-2">
          <div className="d-flex flex-column gap-18-px p-6">
            <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054 ">
                Tên email:<span className="text-F5222D">*</span>
              </p>
              <Form.Item
                name="email"
                className="m-none-form-item text-explan"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập email",
                  },
                  {
                    validator(_, value) {
                      if (!value) return Promise.resolve();

                      // Không cho khoảng trắng và Unicode
                      const asciiNoSpaceRegex = /^[\x21-\x7E]+$/;

                      if (!asciiNoSpaceRegex.test(value)) {
                        return Promise.reject(
                          new Error("Email không được chứa khoảng trắng hoặc ký tự Unicode")
                        );
                      }

                      // Validate email: user@domain.tld
                      const emailRegex =
                        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

                      if (!emailRegex.test(value)) {
                        return Promise.reject(
                          new Error("Email không đúng định dạng")
                        );
                      }

                      return Promise.resolve();
                    },
                  }
                ]}
              >
                <Input
                  placeholder="Tên email"
                  className="custom-input-css"
                />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054 ">
                Thương hiệu hãng xe:<span className="text-F5222D">*</span>
              </p>
              <Form.Item
                name="categoryCarIds"
                className="m-none-form-item text-explan"
                rules={[{ required: true, message: 'Vui lòng chọn thương hiệu hãng xe!' }]}
              >
                <Select
                  placeholder="Thương hiệu hãng xe"
                  mode="multiple"
                  className='custom-scroll-multi-select custom-page-css border rounded overflow-hidden'
                  options={sLCategoryCar}
                  onChange={(values) => {
                    if (!values) return;
                    const fieldPath = ["categoryCarIds"];
                    const hasAll = values.includes(-1);
                    if (hasAll && values.length > 1) {
                      // Nếu có -1 và có thêm cái khác
                      // Kiểm tra xem -1 vừa được chọn hay vừa bị bỏ
                      const onlyAll = values[values.length - 1] === -1;
                      form.setFieldValue(
                        fieldPath,
                        onlyAll ? [-1] : values.filter((v: number) => v !== -1)
                      );
                    }
                  }}
                />
              </Form.Item>
            </div>
            {/* <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054 ">
                Phạm vi hoạt động:<span className="text-F5222D">*</span>
              </p>
              <Form.Item
                name="unitIds"
                className="m-none-form-item text-explan"
                rules={[{ required: true, message: 'Vui lòng chọn phạm vi hoạt động!' }]}
              >
                <TreeSelect
                  treeData={sLNationwide}
                  placeholder="Phạm vi hoạt động"
                  multiple
                  className='custom-scroll-multi-select custom-page-css border rounded overflow-hidden'
                />
              </Form.Item>
            </div> */}
            <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054 ">
                Phạm vi hoạt động:<span className="text-F5222D">*</span>
              </p>
              <Form.Item
                name='unitIds'
                className="m-none-form-item text-explan h-full w-full custom-css-select"
                rules={[{ required: true, message: 'Chọn phạm vi hoạt động!' }]}
              >

                <TreeSelectCustom_V2
                  className="h-full w-full custom-css-select custom-page-css rounded border"
                  data={sLNationwide}
                  // value={selectedIds}                              // ví dụ: [101, 205]
                  value={valuesUnitList}
                  onChange={(ids) => {
                    setValuesUnitList(ids);
                    form.setFieldValue('unitIds', ids);
                  }}  // nhận về [number, ...]
                  cascadeDisable={true}
                  disableMode="disabled"                           // hoặc "disableCheckbox" nếu chỉ muốn khoá tick
                />
                {(valuesUnitList.length ?? 0) > 0 && (
                  <p className="bg-F0F5FF border-ADC6FF rounded-2 text-2F54EB text-sm px-2 d-flex align-center gap-3-px h-auto font-regular justify-between absolute custom-css-count-select">
                    {valuesUnitList.length} đơn vị được chọn
                  </p>
                )}
              </Form.Item>


            </div>
            <div className="text-sm font-regular text-344054">
              Xác thực với:<span className="text-F5222D">*</span>
            </div>

            <Form.Item
              name="authType"
              rules={[{ required: true, message: "Chọn phương thức xác thực!" }]}
              className="m-none-form-item"
            >
              <Radio.Group className="d-flex flex-column gap-4">
                {DataAuthType.map((item) => (
                  <Radio key={item.value} value={item.value}>
                    <span className="text-sm text-4B4B4B">{item.title}</span>
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>

            <div className="text-sm font-regular text-344054">
              Mã hóa kết nối:<span className="text-F5222D">*</span>
            </div>
            <Form.Item
              name="encryptionType"
              rules={[{ required: true, message: "Chọn phương thức xác thực!" }]}
              className="m-none-form-item"
            >
              <Radio.Group className="d-flex flex-column gap-4">
                {DataEncryptionType.map((item) => (
                  <Radio key={item.value} value={item.value}>
                    <span className="text-sm text-4B4B4B">{item.title}</span>
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>

            <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054 ">
                Máy chủ SMTP:<span className="text-F5222D">*</span>
              </p>
              <Form.Item
                name="smtpHost"
                className="m-none-form-item text-explan"
                rules={[{ required: true, message: 'Chọn Máy chủ SMTP!' }]}
              >
                <Input
                  placeholder="Máy chủ SMTP"
                  className="custom-input-css"
                />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054 ">
                Cổng SMTP:<span className="text-F5222D">*</span>
              </p>
              <Form.Item
                name="smtpPort"
                className="m-none-form-item text-explan"
                rules={[{ required: true, message: 'Chọn Cổng SMTP!' }]}
              >
                <Input
                  placeholder="Cổng SMTP"
                  className="custom-input-css"
                />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054 ">
                Tên đăng nhập:<span className="text-F5222D">*</span>
              </p>
              <Form.Item
                name="smtpUsername"
                className="m-none-form-item text-explan"
                rules={[{ required: true, message: 'Nhập tên đăng nhập!' }]}
              >
                <Input
                  placeholder="Tên đăng nhập"
                  className="custom-input-css"
                />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054 ">
                Mật khẩu:<span className="text-F5222D">*</span>
              </p>
              <Form.Item
                name="smtpPassword"
                className="m-none-form-item text-explan"
                rules={[{ required: true, message: 'Nhập mật khẩu!' }]}

              >
                <Input.Password
                  placeholder="Mật khẩu"
                  className="custom-input-css"
                />
              </Form.Item>
            </div>
            {/* <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054 ">
                Chữ ký email:<span className="text-F5222D">*</span>
              </p>
              <Form.Item
                name="emailSignature"
                className="m-none-form-item text-explan"
                rules={[{ required: true, message: 'Nhập Chữ ký email!' }]}

              >
                <Input.Password
                  placeholder="Chữ ký email"
                  className="custom-input-css"
                />
              </Form.Item>
            </div> */}
          </div>
        </div>
      </Modal>
    </Form>
  )
}
export default ModalCreateEmail
